import * as rootSelectors from '../../selectors/root';
import { createSelector } from 'reselect';
import { makeFirebaseUsersArray } from '../../redux/usersSelectors';
import _ from 'lodash';
import moment from 'moment';

export const makeChannelsArray = createSelector(
    [rootSelectors.selectChannels],
    channels => {
        if (channels) {
            return Object.keys(channels).map(key => ({
                ...channels[key],
                id: key,
            }));
        } else {
            return [];
        }
    },
);
export const makeActiveChannel = createSelector(
    [makeChannelsArray, rootSelectors.selectActiveChannelId],
    (channels, channel_id) => {
        return channels.filter(channel => channel.id === channel_id)[0];
    },
);

export const nameOfEditableChannel = createSelector(
    [rootSelectors.selectChannelEditing, makeChannelsArray],
    (id, channels) => {
        return id && channels ? channels.filter(e => e.id === id)[0].name : '';
    },
);

export const isNameHiddenOfEditableChannel = createSelector(
    [rootSelectors.selectChannelEditing, makeChannelsArray],
    (id, channels) => {
        return id && channels && channels.filter(e => e.id === id).length && channels.filter(e => e.id === id)[0].isNameHidden !== undefined ? channels.filter(e => e.id === id)[0].isNameHidden : false;
    },
);

export const makeChannelWhitelist = createSelector(
    [makeActiveChannel, makeFirebaseUsersArray],
    (channel, users) => {
        if (channel && channel.whitelist) {
            let wl = channel.whitelist;
            return Object.keys(wl) //Transform FB object into array
                .map(id => {
                    return {
                        id,
                        name: wl[id],
                        tableData: {
                            //This tableData property is to help ensure whitelist appears selected for material-table
                            checked: true,
                        },
                    };
                });
        } else {
            return [];
        }
    },
);

export const imgOfEditableChannel = createSelector(
    [rootSelectors.selectChannelEditing, makeChannelsArray],
    (id, channels) => {
        return id && channels ? channels.filter(e => e.id === id)[0].imageURL : '';
    },
);

export const makeInitialChannelForm = createSelector(
    [
        rootSelectors.selectChannelEditing,
        rootSelectors.selectChannelsForm,
        nameOfEditableChannel,
        imgOfEditableChannel,
        makeChannelWhitelist,
        isNameHiddenOfEditableChannel
    ],
    (editing, form, name, imageURL, whitelist, isNameHidden) => {
        return {
            ...form,
            name,
            imageURL,
            whitelist,
            isNameHidden
        };
    },
);

export const makeActiveChannelName = createSelector(
    [
        //Useful for channel view
        makeActiveChannel,
    ],
    channel => {
        return channel && channel.name ? channel.name : '';
    },
);
export const makeActiveChannelBackground = createSelector(
    [
        //Useful for channel view
        makeActiveChannel,
    ],
    channel => {
        return channel && channel.imageURL ? channel.imageURL : null;
    },
);

export const makeActiveChannelMessages = createSelector(
    [
        //Useful for channel view
        rootSelectors.selectActiveChannelId,
        rootSelectors.selectMessages,
        rootSelectors.selectUserAvatars,
    ],
    (channel_id, messages, avatars) => {
        let res = messages[channel_id]
            ? messages[channel_id].map(message => {
                  message.timeStampString = moment.unix(message.timestamp).fromNow();
                  let pic = avatars[message.senderId];
                  message.avatar = pic ? pic : null;
                  return message;
              })
            : [];

        return res;
    },
);

export const makeSortedChannelsByIndex = createSelector(
    [makeChannelsArray],
    channels => {
        return _.orderBy(channels, 'index', 'asc');
    },
);

export const makeChannelDetailsFromForm = createSelector(
    //Used to construct the channel object sent for creation or modification
    [rootSelectors.selectChannelsForm],
    form => {
        return {
            imageURL: form.imageURL,
            name: form.name,
            isNameHidden: form.isNameHidden,
        };
    },
);
